export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7156.0fa58bba.jpg";